import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-07_01",
  version: "2026.06.07",
  date: "7 Jun 2026",
  sinceCommit: "88fbb27",
  gameplay: [
    {
      text: "New game mode **Skill Draft** added: Between rounds, build your arsenal of skills by choosing from completely random offers from the void.",
    },
    {
      text: "Bot difficulty tiers for Practice vs Bots and lobby bots: **Noob**, **Novice**, **Master**, and **Archmage**. Hosts can set each bot's tier in the lobby; Practice uses one tier for the whole room.",
    },
    {
      text: "**Noob** and **Novice** bots are much weaker: worse aim, slower reactions, less shopping, and they rarely use defensive spells.",
    },
    {
      text: "Lobby hosts get a **Bot skill** dropdown (applies to all fill bots) when creating a room with bots.",
    },
    {
      text: "Spellbook and shop **synergy hover previews**: mouse over a synergy node to see a preview of the skill in action.",
    },
    {
      text: "Spellbook filters split into separate **Show passives** and **Show synergies** toggles.",
    },
    {
      text: "**\"Learn to Play\"-section**  optimizations: **preview demos** should now render more smoothly.",
    },
    {
      text: "Firebox optimizations."
    },
    {
      text: "Add \"shadow\" keys in skill action bar."
    },
  ],
  skills: [
    {
      spellId: "scourge",
      changes: [
        {
          text: "Allow casting **Teleport** and **Thrust** while channeling **Scourge**.",
        },
      ],
    },
    {
      spellId: "bonespear",
      changes: [
        {
          text: "New spell (**slot 4**, 95 gold, **22s** cooldown): channel **1.2s**, then hurl a bone spear (**96** damage, **0.44s** stun). Projectile speed **2000** — fastest bolt in the game.",
        },
        {
          text: "**Hemorrhage** (5s): you and anyone hit only bleed when they **move** — **0.14 HP** per world unit traveled (standing still is safe).",
        },
        {
          text: "On cast: **5s** slow (**70%** move speed) and **Exhaustion** (5s) — every spell cast while exhausted costs **+3s** cooldown.",
        }
      ],
    },
  ],
};
